import React from "react";
import ClientSection from "../Home/ClientSection";
import ContactForm from "../ContactForm/ContactForm";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import { BASE_URL } from "../../constants";
import member1 from "../../assets/our_teams/member_1.png";
import member3 from "../../assets/our_teams/member_4.png";


const OurTeams = () => {
  return (
    <>
      <Header />
      <section className="team__area pt-90 pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="section__title text-center mb-50">
                <h2 className="teamheading">
                  Team of Experienced Leaders, Engineers <br /> And Data
                  Scientists 
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="team__wrapper">
                <div className="team__item">
                  <div className="team__thumb">
                    <img
                      src={member1}
                      alt="Dsider"
                    />
                  </div>
                  <div className="team__content">
                    <h3>Sujatha Kumar</h3>
                    <span>Founder & CEO</span>
                  </div>
                </div>
                {/* <div className="team__item">
                  <div className="team__thumb">
                    <img
                      src={`${BASE_URL}our_teams/member_2.png`}
                      alt="Dsider"
                    />
                  </div>
                  <div className="team__content">
                    <h3>SV Jain</h3>
                    <span>Co-Founder</span>
                  </div>
                </div> */}
                <div className="team__item">
                  <div className="team__thumb">
                    <img
                      src={`${BASE_URL}our_teams/member_3.png`}
                      alt="Dsider"
                    />
                  </div>
                  <div className="team__content">
                    <h3>Edward Krueger</h3>
                    <span>Data Scientist Deep Tech Architect & Economist</span>
                  </div>
                </div>
                {/* <div className="team__item">
                  <div className="team__thumb">
                    <img
                      src={member3}
                      alt="Dsider"
                    />
                  </div>
                  <div className="team__content">
                    <h3>Umang Jain</h3>
                    <span>Vice President Head of Technology</span>
                  </div>
                </div> */}
                <div className="team__item">
                  <div className="team__thumb">
                    <img
                    style= {{ height: "240px", width: "240px" }} 
                      src={`${BASE_URL}our_teams/Payal.png`}
                      alt="Dsider"
                    />
                  </div>
                  <div className="team__content">
                    <h3>Payal Patel</h3>
                    <span>Chief of Staff</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="section__title section__title-2 text-center pt-90 mb-50">
                <h2>Advisors</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="team__wrapper advisor">
                <div className="team__item">
                  <div className="team__thumb">
                    <div className="logo">
                      <img src={`${BASE_URL}our_teams/logo_1.png`}  alt="Dsider" />
                    </div>
                    <div className="teamImg">
                      <img
                        src={`${BASE_URL}our_teams/advisor_1.png`}
                        alt="Dsider"
                      />
                    </div>
                  </div>
                  <div className="team__content avd">
                    <h3>Jane Stricker</h3>
                    <span>Managing Director, HETI</span>
                    <span>Energy Transition Advisor</span>
                  </div>
                </div>
                <div className="team__item">
                  <div className="team__thumb">
                    <div className="logo">
                      <img src={`${BASE_URL}our_teams/logo_2.png`}  alt="Dsider" />
                    </div>
                    <div className="teamImg">
                      <img
                        src={`${BASE_URL}our_teams/advisor_2.png`}
                        alt="Dsider"
                      />
                    </div>
                  </div>
                  <div className="team__content avd">
                    <h3>Hani Elshahawi</h3>
                    <span>Retired Digital Lead</span>
                    <span>Decarbonization & Digital Advisor</span>
                  </div>
                </div>
                <div className="team__item">
                  <div className="team__thumb">
                    <div className="logo">
                      <img src={`${BASE_URL}our_teams/logo_2.png`}  alt="Dsider" />
                    </div>
                    <div className="teamImg">
                      <img
                        src={`${BASE_URL}our_teams/advisor_3.png`}
                        alt="Dsider"
                      />
                    </div>
                  </div>
                  <div className="team__content avd">
                    <h3>Dr. Malcolm Ross</h3>
                    <span>Retired Geothermal Lead</span>
                    <span>Geothermal Advisor</span>
                  </div>
                </div>
                <div className="team__item">
                  <div className="team__thumb">
                    <div className="logo">
                      <img src={`${BASE_URL}our_teams/logo_2.png`}  alt="Dsider" />
                    </div>
                    <div className="teamImg">
                      <img
                        src={`${BASE_URL}our_teams/advisor_4.png`}
                        alt="Dsider"
                      />
                    </div>
                  </div>
                  <div className="team__content avd">
                    <h3>Amy Henry</h3>
                    <span>Advisor, Energy Industry</span>
                  </div>
                </div>
                <div className="team__item">
                  <div className="team__thumb">
                    <div className="logo">
                      <img src={`${BASE_URL}our_teams/logo_3.png`}  alt="Dsider" />
                    </div>
                    <div className="teamImg">
                      <img
                        src={`${BASE_URL}our_teams/advisor_5.png`}
                        alt="Dsider"
                      />
                    </div>
                  </div>
                  <div className="team__content avd">
                    <h3>Matt Doan</h3>
                    <span>CEO Delmar Aerospace</span>
                    <span>Investor</span>
                  </div>
                </div>
                <div className="team__item">
                  <div className="team__thumb">
                    <div className="logo">
                      <img src={`${BASE_URL}our_teams/logo_4.png`}  alt="Dsider" />
                    </div>
                    <div className="teamImg">
                      <img
                        src={`${BASE_URL}our_teams/advisor_6.png`}
                        alt="Dsider"
                      />
                    </div>
                  </div>
                  <div className="team__content avd">
                    <h3>Ramachandra Shenoy</h3>
                    <span>CEO, RBR group</span>
                    <span>Investor</span>
                  </div>
                </div>
                <div className="team__item">
                  <div className="team__thumb">
                    <div className="logo">
                      <img src={`${BASE_URL}our_teams/logo_5.png`}  alt="Dsider" />
                    </div>
                    <div className="teamImg">
                      <img
                        src={`${BASE_URL}our_teams/advisor_7.png`}
                        alt="Dsider"
                      />
                    </div>
                  </div>
                  <div className="team__content avd">
                    <h3>Sunil Garg</h3>
                    <span>Position, DataVedik</span>
                    <span>Technology Advisor</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ClientSection />
      <ContactForm showFooter={false} />
      <NewFooter />
    </>
  );
};

export default OurTeams;
